import { render } from "./ProductByDeparDetail.vue?vue&type=template&id=69711cf2&scoped=true"
import script from "./ProductByDeparDetail.vue?vue&type=script&lang=js"
export * from "./ProductByDeparDetail.vue?vue&type=script&lang=js"

import "./ProductByDeparDetail.vue?vue&type=style&index=0&id=69711cf2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69711cf2"]])

export default __exports__